define(["require", "exports", "tslib", "@material-ui/core/MenuItem", "@material-ui/core/Select", "mobx-react", "react", "./index"], function (require, exports, tslib_1, MenuItem_1, Select_1, mobx_react_1, React, index_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.makeDomainField = exports.DomainField = void 0;
    MenuItem_1 = tslib_1.__importDefault(MenuItem_1);
    Select_1 = tslib_1.__importDefault(Select_1);
    React = tslib_1.__importStar(React);
    let DomainField = exports.DomainField = class DomainField extends React.Component {
        constructor(props) {
            super(props);
            Object.defineProperty(this, "required", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "maxLength", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "tooltip", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "handleChange", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (e) => {
                    const value = e.target.value;
                    const { propertyOwner, propertyName, onChange } = this.props;
                    const oldVal = propertyOwner[propertyName];
                    console.log("change", propertyName, oldVal, value);
                    propertyOwner[propertyName] = value;
                    if (onChange) {
                        onChange(propertyOwner, propertyName, oldVal, value);
                    }
                }
            });
            this.required = props.propertyOwner.constructor[props.propertyName + "Req"] || false;
            this.maxLength = props.propertyOwner.constructor[props.propertyName + "Length"] || 255;
            this.tooltip = props.tooltip || props.propertyOwner.constructor[props.propertyName + "Tooltip"] || "";
        }
        render() {
            var _a;
            const { id, domain, propertyOwner, propertyName, hideLabel, hideTooltip } = this.props;
            if (typeof domain === "string") {
                if (!propertyOwner[domain]) {
                    throw new Error(`Invalid or undefined Domain type provided ${domain}`);
                }
            }
            const domainValues = typeof domain === "string" ? propertyOwner[domain].Values : domain.Values;
            const error = propertyOwner[propertyName + "Error"];
            const useTooltip = !hideTooltip && this.tooltip && this.tooltip.length > 50;
            const value = ((_a = propertyOwner[propertyName]) !== null && _a !== void 0 ? _a : "");
            const field = makeDomainField(Object.assign(Object.assign({}, this.props), { domainValues,
                value,
                error, required: this.required, onChange: this.handleChange }));
            if (!hideLabel) {
                return (React.createElement(index_1.HGroup, { className: "form-field" },
                    React.createElement("span", { className: "label" }, id),
                    React.createElement(index_1.VGroup, { style: { flexGrow: 1 } },
                        field,
                        error && React.createElement("div", { className: "field-error-label" }, error)),
                    useTooltip
                        ? React.createElement(index_1.Tooltip, { text: this.tooltip, style: { alignItems: "flex-start" } })
                        : null));
            }
            else {
                return (React.createElement(index_1.HGroup, { style: { flexGrow: 1 } },
                    React.createElement(index_1.VGroup, { style: { flexGrow: 1 } },
                        field,
                        error && React.createElement("div", { className: "field-error-label" }, error)),
                    useTooltip
                        ? React.createElement(index_1.Tooltip, { text: this.tooltip, style: { alignItems: "flex-start" } })
                        : null));
            }
        }
    };
    exports.DomainField = DomainField = tslib_1.__decorate([
        mobx_react_1.observer
    ], DomainField);
    function makeDomainField(props) {
        const { id, style, domainValues, value, error, required, disabled, fullWidth, noSelectionLabel, onChange } = props;
        const classNames = ["field-domain"];
        if (error || (required && !disabled && (value == undefined || value == null))) {
            classNames.unshift("field-required");
        }
        if (disabled) {
            classNames.unshift("field-domain-disabled");
        }
        return React.createElement(Select_1.default, { id: id, className: classNames.join(" "), disabled: disabled, value: value, fullWidth: fullWidth, style: style || {
                fontSize: "inherit",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "pre",
                borderBottom: "1px solid rgb(158, 158, 158)"
            }, onChange: onChange },
            noSelectionLabel
                ? React.createElement(MenuItem_1.default, { key: undefined, value: undefined }, noSelectionLabel)
                : null, domainValues === null || domainValues === void 0 ? void 0 :
            domainValues.map(x => {
                return React.createElement(MenuItem_1.default, { key: x.key, value: x.key }, x.value);
            }));
    }
    exports.makeDomainField = makeDomainField;
});
